// extracted by mini-css-extract-plugin
var _1 = "Benefits_benefit__pghoH";
var _2 = "Benefits_benefitsContainer__ApYDR";
var _3 = "Benefits_description__VZAZd";
var _4 = "Benefits_descriptionContainer__haH7l";
var _5 = "Benefits_image__cUdaX";
var _6 = "Benefits_legalReference__A8phm";
var _7 = "992px";
var _8 = "Benefits_logoBenefit__SJ3D-";
var _9 = "768px";
var _a = "'../../../shared.module.css'";
var _b = "1200px";
export { _1 as "benefit", _2 as "benefitsContainer", _3 as "description", _4 as "descriptionContainer", _5 as "image", _6 as "legalReference", _7 as "lg", _8 as "logoBenefit", _9 as "md", _a as "shared", _b as "xl" }
